
import dateConf from '../../utils/date';
import IconCalendar from '../../icons/icon-calendar/index.vue';
import Dropdown from '../dropdown/index.vue';
import DateCalendar from '../date-calendar/index.vue';
import IconCross from '../../icons/icon-cross/index.vue';

export default {
  name: 'rzDateCalendarInput',
  components: {
    IconCalendar,
    Dropdown,
    DateCalendar,
    IconCross,
  },
  directives: {
    mask: {
      bind(el, binding) {
        const Inputmask = require('inputmask').default;
        Inputmask(binding.value).mask(el);
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    placeholder: {
      type: String,
      default: 'Дата рождения',
    },
    locale: {
      type: String,
      default: 'ru',
    },
    validationErrorText: {
      type: String,
      default: 'Введите корректную дату',
    },
    initialYear: {
      type: [Number],
      default: 1980,
    },
    yearMin: {
      type: Number,
      default: 1900,
    },
    yearMax: {
      type: Number,
      default: new Date().getFullYear(),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    dateBefore: {
      type: Object,
      default() {
        return null;
      },
    },
    errorText: {
      type: String,
      default: '',
    },
    prices: {
      type: Object,
      default: () => {},
    },
    avaliable: {
      type: Object,
      default: () => {},
    },
    isError: Boolean,
    required: Boolean,
    clearable: Boolean,
    range: Boolean,
    byWeek: Boolean,
    withTime: Boolean,
  },
  data() {
    return {
      inputDateString: '',
      isOpen: false,
      isFirstState: true,
      mobileDateOfBirth: '',
      focused: false,
      calendarModel: {
        value: {
          date: '',
          month: { value: '', label: '' },
          year: '',
        }
      },
    };
  },
  computed: {
    classes () {
      return {
        'date-calendar-input__control--error': this.isError || this.calendarModel.value.isValid === false, 
        'date-calendar-input__control--filled': !this.focused && this.inputDateString, 
        'date-calendar-input__control--focused': this.focused || this.isOpen,
      };
    },
    placeholderClasses () {
      return {
        'date-calendar-input__placeholder--focused': this.focused,
        'date-calendar-input__placeholder--filled': !this.focused && this.inputDateString
      };
    },
    inputMask () {
      return this.range || this.byWeek
        ? '99.99.9999 - 99.99.9999'
        : this.withTime 
          ? '99.99.9999 99:99'
          : '99.99.9999';
    }
  },
  watch: {
    value: {
      handler(value) {
        if (!this.range && !this.byWeek && this.isValidDateObject(value)) {
          this.$set(this, 'inputDateString', this.getDateString(value));
          this.$set(this.calendarModel, 'value', value);
          this.$set(this.calendarModel.value, 'isValid', this.isValidDate(this.inputDateString));
          this.$emit('change', value);
        } else if (
          value.from &&
          value.to &&
          this.isValidDateObject(value.to) &&
          this.isValidDateObject(value.from)
        ) {
          const toDateString = this.getDateString(value.to);
          const fromDateString = this.getDateString(value.from);
          this.$set(this, 'inputDateString', `${fromDateString} - ${toDateString}`);
          this.$set(this.calendarModel, 'value', value);
          this.$set(this.calendarModel.value, 'isValid', this.isValidRange(value.from, value.to));
          this.$emit('change', value);
        } else {
          this.$set(this.calendarModel, 'value', value);
          this.$set(this, 'inputDateString', ``);
        }
      },
      immediate: true,
      deep: true,
    },
    isOpen: {
      handler(value) {
        this.$emit('switch-dropdown', value);
      }
    },
  },
  methods: {
    getDateString (dateObject) {
      if (!this.isValidDateObject(dateObject)) return '';
      const date = dateObject.date;
      const month = dateObject.month.value;
      const time = dateObject.time || '';
      return `${date}.${month}.${dateObject.year}${this.withTime ? ` ${time.hours || '00'}:${time.minutes || '00'}` : ''}`;
    },
    getDateObjectTime (dateString) {
      const splitted = dateString.split(' ');
      if (splitted.length < 2) return {};
      const newDateObject = this.getDateObject(splitted[0]);
      const timeObject = this.getTimeObject(splitted[1]);
      this.$set(newDateObject, 'time', timeObject);
      return newDateObject;
    },
    getTimeObject (timeString) {
      const splitted = timeString.split(':');
      return {
        full: `${timeString}:00`,
        hours: splitted[0],
        minutes: splitted[1],
      };
    },
    getDateObject (dateString) {
      const splitted = dateString.split('.');

      if (splitted.length < 3) return {};
      if (
        splitted[0].length !== 2 || 
        splitted[1].length !== 2 || 
        splitted[2].length !== 4 ||
        Number(splitted[1]) === 0
      ) return {};

      const monthName = dateConf[this.locale].months[splitted[1] - 1].full;

      return {
        date: splitted[0],
        month: { value: splitted[1], label: monthName },
        year: splitted[2],
      };
    },
    isValidDateObject (dateObject) {
      if (!dateObject || !Object.keys(dateObject).length) return false;
      
      const valid = !!dateObject.year &&
        !!dateObject.month &&
        !!dateObject.date &&
        !!Object.keys(dateObject.month).length &&
        !!dateObject.month.value;

      return valid;
    },
    isValidDate(str) {
      if(str && str!==''){
        const input = str.match(/\d+/g);
        const date = new Date(input[2], input[1] - 1, input[0]);
        const validTime = this.withTime
          ? parseInt(input[3], 10) < 24 && parseInt(input[4], 10) < 60
          : true; 
        const valid = date.getFullYear() === parseInt(input[2],10) &&
          date.getDate() === parseInt(input[0],10) &&
          date.getMonth() === parseInt(input[1] - 1, 10) &&
          parseInt(input[2],10) <= this.yearMax &&
          parseInt(input[2],10) >= this.yearMin &&
          validTime;
        return valid;
      }
      return true;
    },
    isValidRange (from, to) {
      if (!from || !to) return false;
      const fromString = this.getDateString(from);
      const toString = this.getDateString(to);
      const fromValid = this.isValidDate(fromString);
      const toValid = this.isValidDate(toString);
      const fromDate = new Date(from.year, from.month.value - 1, from.date);
      const toDate = new Date(to.year, to.month.value - 1, to.date);
      const rangeValid = fromValid && toValid && fromDate <= toDate;


      if (this.byWeek) {
        const diff = Math.abs(fromDate - toDate);
        const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
        return rangeValid && diffDays === 6; 
      }

      return rangeValid;
    },
    inputDate (event) {
      const {value} = event.target;
      this.$set(this, 'inputDateString', value);

      if (value.includes('_')) return;
      if (value === '') {
        this.$set(this.calendarModel, 'value', {});
        this.$emit('change', this.calendarModel.value);
        return;
      }

      if (this.range || this.byWeek) {
        this.inputRange(value);
      } else {
        this.inputSingle(value);
      }

      this.$emit('change', this.calendarModel.value);
    },
    inputSingle (value) {
      const dateObject = this.withTime ? this.getDateObjectTime(value) : this.getDateObject(value);
      this.$set(dateObject, 'isValid', this.isValidDate(value));
      this.$set(this.calendarModel, 'value', { ...dateObject });
    },
    inputRange (value) {
      const from = value.split('-')[0].trim();
      const to = value.split('-')[1].trim();
      const fromObject = this.getDateObject(from);
      const toObject = this.getDateObject(to);
      const isValid = this.isValidRange(fromObject, toObject);

      this.$set(this.calendarModel, 'value', { from: fromObject, to: toObject, isValid });
    },
    switchCalendar(e) {
      if (this.isOpen) this.hideCalendar();
      else this.openCalendar(e);
    },
    openCalendar(e) {
      e.target.select();
      this.focused = true;
      if (this.isMobile) return;
      this.isOpen = true;
    },
    hideCalendar() {
      this.isOpen = false;
      this.focused = false;
    },
    applyChanges() {
      this.isFirstState = false;
      this.$emit('change', this.calendarModel.value);
    },
    enter() {
      this.$emit('enter');
    },
    focusout(event) {
      if (this.$refs.container.contains(event.relatedTarget)) return;
      this.focused = false;
      this.hideCalendar();
    },
    clean() {
      this.$emit('change', {});
    },
  },
};
